// Runtime API base URL — uses the browser's current origin so API calls
// are always same-origin, regardless of which domain serves the app
// (preview, production custom domain, etc.)
export const API = `${window.location.origin}/api`;
export const BACKEND = window.location.origin;
export const WS_BASE = window.location.origin.replace('https://', 'wss://').replace('http://', 'ws://');
